<div class="flex flex-col gap-4
            lg:flex-row lg:justify-between lg:items-center">

  <app-reports-summary-header
    [totals]="totals()">
  </app-reports-summary-header>

  <app-report-actions
    class="w-full lg:w-auto"
    [request]="reportRequest()"
    [downloadFn]="downloadSummaryReport">
  </app-report-actions>

</div>

<app-chart-stacked-bar
  class="mt-4"
  [chartData]="chartData()">
</app-chart-stacked-bar>

<p-divider class="my-6" />

<app-summary-table
  [isOwner]="isOwner()"
  [summaryData]="summaryData()">
</app-summary-table>
